module.exports = __webpack_public_path__ + "img/zwsp.a5ac3e30.png";